import 'van11y-accessible-accordion-aria';
import { Component } from '../core/component';

export class Accordion extends Component {
    constructor() {
        super();
        this.selector = '[data-accordion]';
    }

    init() {
        const accordions = document.querySelectorAll(this.selector);

        const config = {
            // ACCORDION_JS: 'js-accordion',
            // ACCORDION_JS_HEADER: 'js-accordion__header',
            // ACCORDION_JS_PANEL: 'js-accordion__panel',

            // ACCORDION_DATA_PREFIX_CLASS: 'data-accordion-prefix-classes',
            // ACCORDION_DATA_OPENED: 'data-accordion-opened',
            // ACCORDION_DATA_MULTISELECTABLE: 'data-accordion-multiselectable',
            // ACCORDION_DATA_COOL_SELECTORS: 'data-accordion-cool-selectors',

            // ACCORDION_PREFIX_IDS: 'accordion',
            // ACCORDION_BUTTON_ID: '_tab',
            // ACCORDION_PANEL_ID: '_panel',

            // ACCORDION_STYLE: 'accordion',
            // ACCORDION_TITLE_STYLE: 'accordion__title',
            // ACCORDION_HEADER_STYLE: 'accordion__header',
            // ACCORDION_PANEL_STYLE: 'accordion__panel',
        };

        accordions.forEach((accordion) => {
            const initAccordion = van11yAccessibleAccordionAria(config);
            initAccordion.attach(accordion);
        });
    }
}
